import { ExpiredStatus } from '@cat-ecom/pcc-components';
import { getFormattedDate } from 'components/notifications/utils/utils';
import { useTranslations } from 'next-intl';

const ExpiredStatusWrapper = ({
  link,
  quoteExpireDate
}: {
  link: string;
  quoteExpireDate: string;
}) => {
  const t = useTranslations();
  const today = new Date();
  const isTodayDate =
    getFormattedDate(today) === getFormattedDate(quoteExpireDate);

  return (
    <ExpiredStatus
      {...(isTodayDate && { isTodayDate: isTodayDate.toString() })}
      link={link}
      REVIEW_QUOTE={t('REVIEW_QUOTE')}
      VIEW_QUOTE={t('VIEW_QUOTE')}
    />
  );
};

export default ExpiredStatusWrapper;
